import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.$links = this.$('link')
        this.dotId = this.getData('dot')
    }

    init() {
        this.parentBCR = this.el.parentNode.getBoundingClientRect()
        this.activeLink = Array.from(this.$links).find(el => el.classList.contains('-active'))
        this.updateDot(this.activeLink, true)

        for(let link of Array.from(this.$links)) {
            this.linkFocusBind = this.onLinkFocus.bind(this)
            link.addEventListener('mouseenter', this.linkFocusBind)
            link.addEventListener('focus', this.linkFocusBind)

            this.linkBlurBind = this.onLinkBlur.bind(this)
            link.addEventListener('mouseleave', this.linkBlurBind)
            link.addEventListener('blur', this.linkBlurBind)
        }

        this.resizeBind = () => {
            if(!this.resizeTick) {
                requestAnimationFrame(() => {
                    this.parentBCR = this.el.parentNode.getBoundingClientRect()
                    this.updateDot(this.activeLink, true)
                    this.resizeTick = false
                })
                this.resizeTick = true
            }
        }
        window.addEventListener('resize', this.resizeBind)
    }

    onLinkFocus(e) {
        this.updateDot(e.currentTarget)
    }

    onLinkBlur() {
        this.updateDot(this.activeLink)
    }

    setDotById(id) {
        let links = Array.from(this.$links)

        if(this.activeLink) this.activeLink.classList.remove('-active');
        this.activeLink = links.find(el => this.getData('id',el) == id)
        this.activeLink.classList.add('-active');

        this.updateDot(this.activeLink, true)
    }

    updateDot(el, force = false) {
        if(!el) return

        let BCR = el.parentNode.getBoundingClientRect()
        let offset
        if(window.innerWidth > 1200) {
            offset = (this.parentBCR.left - BCR.left) * 2
        } else {
            offset = (this.parentBCR.left - BCR.left)
        }

        if(this.dotId)
            this.call('setTarget', { value: { x: BCR.left + offset, y: BCR.top + BCR.height/2 }, force }, 'Navdot', this.dotId)
    }

    destroy() {
        window.removeEventListener('resize', this.resizeBind)
    }
}
